import { Injectable } from '@angular/core';
import { AccommodationPricePlan } from 'models';
import { PaymentValidationTypesAdmin } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AccommodationPricePlanService {
    constructor(private http: HttpClient) {}

    public get(): Observable<AccommodationPricePlan[]> {
        return this.http.get<AccommodationPricePlan[]>(`api/accommodationpriceplan/`);
    }

    public getById(id: number): Observable<AccommodationPricePlan> {
        return this.http.get<AccommodationPricePlan>(`api/accommodationpriceplan/${id}`);
    }

    public getNewPricePlans(): Observable<PaymentValidationTypesAdmin[]> {
        return this.http.get<PaymentValidationTypesAdmin[]>(`api/accommodationpriceplan/new-price-plans`);
    }

    public save(verificationSetAdmin: AccommodationPricePlan): Observable<void> {
        return this.http.post<void>(`api/accommodationpriceplan/`, verificationSetAdmin);
    }

    public updateAccommodationWithPricePlan(paymentValidationSetId: number, accommodationId: number): Observable<void> {
        return this.http.post<void>(`api/accommodationpriceplan/update-accommodation-with-price-plan/${paymentValidationSetId}/${accommodationId}`, null);
    }
}